// A mock function to mimic making an async request for data
export function fetchProduct(pid) {
    return fetch(process.env.REACT_APP_BASE_API + 'order/apis/getProducts.php?pid=' + pid)
      .then(response => response.json())
}

export function fetchProductPromo(data) {
  return fetch(process.env.REACT_APP_BASE_API + 'order/apis/getProductsPromo.php?pid=' + data.pid + '&billingcycle=' + data.billingcycle + '&promocode=' + data.promocode)
    .then(response => response.json())
}